import { Navigate, Outlet } from 'react-router-dom';
import axios from 'axios';

const AuthenticatedRoutes = () => {
  return localStorage.getItem('token') ? <Outlet /> : <Navigate to="/login" />;
};

export default AuthenticatedRoutes;
